<template>
  <NumberField
    v-if="contactCapture?.isFieldVisible(name)"
    v-bind="$props"
    type="number"
    :label="label ?? $t('form.field.schoolSize.label')"
    :placeholder="placeholder ?? $t('form.field.schoolSize.placeholder')"
    @update:model-value="$emit('update:modelValue', $event)"
  />
</template>

<script lang="ts">
export type SchoolSizeFieldProps = NumberFieldProps & {
  placeholder?: string;
};
export type SchoolSizeFieldEvents = NumberFieldEvents;
</script>

<script setup lang="ts">
import { useContactCaptureContext } from "@/components/forms/useContactCapture";
import NumberField, {
  NumberFieldEvents,
  NumberFieldProps,
} from "./NumberField.vue";

withDefaults(defineProps<SchoolSizeFieldProps>(), {
  name: "school-size",
});
defineEmits<SchoolSizeFieldEvents>();

const contactCapture = useContactCaptureContext();
</script>
